// src/components/Admin/VerificationManagement.tsx
import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';

// Use a more generic interface for the documents
interface StallDocument {
  id: string;
  businessName: string;
  category: string;
  nidDocumentUrl: string;
  titleOrLogbookDocumentUrl: string;
  verificationStatus: 'pending' | 'verified';
}

const VerificationManagement: React.FC = () => {
  const [pendingStalls, setPendingStalls] = useState<StallDocument[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPendingStalls = async () => {
      try {
        // Create a query to find stalls with a 'pending' verification status
        const stallsRef = collection(db, 'stalls');
        const q = query(stallsRef, where('verificationStatus', '==', 'pending'));
        const querySnapshot = await getDocs(q);

        const fetchedStalls: StallDocument[] = querySnapshot.docs.map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            businessName: data.businessName,
            category: data.category,
            nidDocumentUrl: data.nidDocumentUrl,
            titleOrLogbookDocumentUrl: data.titleOrLogbookDocumentUrl,
            verificationStatus: data.verificationStatus,
          };
        });
        
        setPendingStalls(fetchedStalls);
      } catch (error) {
        console.error("Error fetching pending stalls:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPendingStalls();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h2>Pending Verification Requests</h2>
      
      {pendingStalls.length === 0 ? (
        <p>No new documents to verify at this time.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Stall ID</th>
              <th>Business Name</th>
              <th>Category</th>
              <th>National ID</th>
              <th>Property/Vehicle Document</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {pendingStalls.map(stall => (
              <tr key={stall.id}>
                <td>{stall.id}</td>
                <td>{stall.businessName}</td>
                <td>{stall.category}</td>
                <td>
                  <a href={stall.nidDocumentUrl} target="_blank" rel="noopener noreferrer">
                    View National ID
                  </a>
                </td>
                <td>
                  <a href={stall.titleOrLogbookDocumentUrl} target="_blank" rel="noopener noreferrer">
                    View Document
                  </a>
                </td>
                <td>{stall.verificationStatus}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default VerificationManagement;